<template>
  <div class="page_container warehousingRecordPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>入库操作追溯记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl"></div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="searchTxt"
              placeholder="输入SKU编码/ISBN编码查找匹配商品"
              @keyup.enter.native="handleSearch"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="search_wrap flex-between">
            <el-date-picker v-model="datestr" type="date" placeholder="选择日期">
            </el-date-picker>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <h1>商品名称：</h1>
                    <p>
                      <span>{{ item.cm ? item.cm.commodityname : "" }}</span>
                    </p>
                    <p>
                      <span>{{ item.cm ? item.cm.commodityname_e : "" }}</span>
                    </p>
                    <p>
                      <span>{{ item.cm ? item.cm.commodityname_y : "" }}</span>
                    </p>
                    <p>
                      <span>{{ item.cm ? item.cm.commodityname_m : "" }}</span>
                    </p>
                    <p>
                      <span>{{ item.cm ? item.cm.commodityname_t : "" }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      入库数量：<span>{{ item.realnum }}</span>
                    </p>
                    <p>
                      商品ID：<span>{{ item.cm ? item.cm.id : "" }}</span>
                    </p>
                    <p>
                      SKU采购编码：<span>{{ item.cm ? item.cm.sku : "" }}</span>
                    </p>
                    <p>
                      ISBN编码：<span>{{ item.cm ? item.cm.ISBN : "" }}</span>
                    </p>
                    <p>
                      是否精品推荐：<span>{{ item.isintro }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      操作日期：<span>{{ item.createdate }}</span>
                    </p>
                    <p>
                      操作人员：<span>{{ item.userman }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div class="detail_icon" @click="handleDetail(item)">
                  <i class="iconfont icon-details"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无入库记录"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { queryShopWareRecord } from "../../api/api";
import storage from "../../utils/storage";

export default {
  name: "wRecordIndex",
  data() {
    return {
      loading: false,
      datestr: "",
      searchTxt: "",
      dataList: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.loading = true;
      queryShopWareRecord({ keyword: this.searchTxt, datestr: this.datestr }).then((res) => {
        this.dataList = res;
        this.loading = false;
      });
    },

    handleDetail(item) {
      storage.set("DETAILITEM", item);
      this.$router.push("/recordIndex/wRecordDetail");
    },
    handleSearch() {
      this.initData();
    },
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingRecordPage {
  .operation_wrap {
    .search_wrap {
      width: 310px;
      &:last-child {
        width: 220px;
        margin-left: 20px;
      }
    }
  }

  .list_wrap {
    height: 58vh;
    .item_main_wrap {
      align-items: center;
    }
    .edit_group {
      .detail_icon {
        cursor: pointer;
        .iconfont {
          color: #838383;
          font-size: 30px;
        }
      }
    }
  }
}
</style>